import { render, staticRenderFns } from "./AddClaimReview.vue?vue&type=template&id=1d36c712"
import script from "./AddClaimReview.vue?vue&type=script&lang=ts"
export * from "./AddClaimReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports